import { render, staticRenderFns } from "./WizardViewLawyer.vue?vue&type=template&id=31e66478&"
import script from "./WizardViewLawyer.vue?vue&type=script&lang=js&"
export * from "./WizardViewLawyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports